import { render, staticRenderFns } from "./phmeter-termo.vue?vue&type=template&id=a5da7296&"
import script from "./phmeter-termo.vue?vue&type=script&lang=js&"
export * from "./phmeter-termo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports